import { Component, ChangeDetectionStrategy, effect, inject, input, output } from '@angular/core';
import { DynamicLocaleService } from '../../../dynamic-locale.service';
import { GroupBase } from '../../../models/blueprint.model';
import {
  GroupedDataRecordModel,
  RecordUpdateEmission,
  ReportOptions,
  ReportView,
  TemplateProjectionMap,
} from '../../../models/report.model';
import { TemplateField } from '../../../models/template.model';
import { EditableFieldsService } from '../../editable-fields.service';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { ReportFieldFormatterPipe } from '../../../shared/pipes/report-field-formatter.pipe';
import { SelectTemplateOutletPipe } from '../../../shared/pipes/select-template-outlet.pipe';
import { ReportFieldRouteFnPipe } from '../../../shared/pipes/report-field-route-fn.pipe';
import { DisplayFieldPipe } from '../display.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-condensed-header',
  templateUrl: './condensed-header.component.html',
  styleUrl: './condensed-header.component.scss',
  imports: [
    NgClass,
    NgTemplateOutlet,
    AsyncPipe,
    ReportFieldFormatterPipe,
    SelectTemplateOutletPipe,
    ReportFieldRouteFnPipe,
    DisplayFieldPipe
],
})
export class CondensedHeaderComponent {
  public editableFieldsService = inject(EditableFieldsService);
  private readonly dynamicLocaleService = inject(DynamicLocaleService);

  readonly reportRecordData = input.required<GroupedDataRecordModel>();
  readonly headerGroups = input.required<GroupBase<TemplateField>[]>();
  readonly currentView = input.required<ReportView>();
  readonly templateProjectionMap = input.required<TemplateProjectionMap>();
  readonly reportOptions = input.required<ReportOptions>();

  readonly reportUpdateClick = output<RecordUpdateEmission>();

  titleGroup: GroupBase<TemplateField>;
  attributesGroup: GroupBase<TemplateField>;

  constructor() {
    effect(() => {
      const headerGroups = this.headerGroups();
      this.editableFieldsService.mapEditableFields(headerGroups);
      const [titleGroup, attributesGroup] = headerGroups;
      this.titleGroup = titleGroup;
      this.attributesGroup = attributesGroup;
    });
  }

  emitEditableFields(event: MouseEvent, id: number) {
    const emittedObject = this.editableFieldsService.generateRecordUpdateEmission(
      event,
      id,
      this.reportRecordData().data[0]
    );
    if (emittedObject != null) {
      emittedObject.locale = this.dynamicLocaleService.reportLocale;
      this.reportUpdateClick.emit(emittedObject);
    }
  }
}
